<template>
  <div style="text-align: center;margin-top: 6%;margin-left: 1%;">
    <div style="margin-top: 10px">我们将为您跳转至用户引导页面，同时为您启动MOA AI诊修工具修复您的问题...</div>
    <div style="margin-top: 10px">若AI诊修工具启动不成功，请您根据引导页面进行手动修复.</div>
    <div style="margin-top: 10px">（We will redirect you to the user guide and launch the MOA AI Agent tool to resolve the issue...</div>
    <div style="margin-top: 10px">If the tool fails to start, please refer to the guide for manual repair）</div>
  </div>
</template>

<script>
export default {
  name: "ai",
  mounted() {
    window.location.href = 'moaaiapp://safeAccessFromBrowser';
    setTimeout(() => {
      const toIndex = this.$route.query.toIndex || '2-1';
      this.$router.push({path: '/templateHtml', query: {index: toIndex}});
    }, 2000); // 延迟2秒执行
  },
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// ai.vue?2eac8f13